import { Drawer, IconButton, Paper, Stack, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import Search from "components/Search/Search";
import Close from "@mui/icons-material/Close";
import FlightDetails from "./FlightDetails";
import { useDispatch, useSelector } from "react-redux";
import { updateSearchQuery, searchQuerySelector } from "redux/searchQuery";
import { searchFormSelector } from "redux/searchForm";
import { Logo, deepCloneObject, isDiff } from "@thekilroygroup/shared-ui";
import { LanguageSelector } from "../LanguageSelector/LanguageSelector";

interface IProps {
  triggerFetch: () => void;
  navigateToLowpriceCalendar?: () => void;
}

export default function MobileSearchHeader(props: IProps) {
  const { triggerFetch } = props;
  const theme = useTheme();
  const dispatch = useDispatch();
  const [searchOpen, setSearchOpen] = useState(false);
  const searchForm = useSelector(searchFormSelector);
  const searchQuery = useSelector(searchQuerySelector);

  useEffect(() => {
    searchForm.flights.forEach((flight) => {
      const arrivalError =
        flight.validation.arrival.dirty === true &&
        !flight.validation.arrival.valid;
      const departureError =
        flight.validation.departure.dirty === true &&
        !flight.validation.departure.valid;
      const departureDateError =
        flight.validation.departureDate.dirty === true &&
        !flight.validation.departureDate.valid;
      if (arrivalError || departureError || departureDateError) {
        setSearchOpen(true);
        return;
      }
    });
  }, [searchForm.flights]);

  const handleFlightDetailsClick = () => {
    setSearchOpen(true);
  };

  const handleClose = () => {
    setSearchOpen(false);
    dispatch(updateSearchQuery(searchForm));
  };

  const submitSearch = () => {
    setSearchOpen(false);
    if (!isDiff(searchForm, searchQuery)) {
      triggerFetch();
    } else {
      dispatch(updateSearchQuery(deepCloneObject(searchForm)));
      triggerFetch();
    }
  };

  return (
    <>
      <Stack alignItems="start" flex={1}>
        <Logo height={18} color={theme.palette.white.main} />
      </Stack>
      <Stack
        alignItems="center"
        sx={{ cursor: "pointer" }}
        onClick={handleFlightDetailsClick}
      >
        <FlightDetails />
      </Stack>
      <Stack flex={1} alignItems="end">
        <LanguageSelector color="white" />
      </Stack>
      <Drawer anchor="bottom" open={searchOpen} onClose={handleClose}>
        <IconButton
          className="closeButton"
          onClick={handleClose}
          color="primary"
        >
          <Close fontSize="medium" color="primary" />
        </IconButton>
        <Paper sx={{ py: 2 }}>
          <Search handleSubmit={submitSearch} {...props} />
        </Paper>
      </Drawer>
    </>
  );
}
